import { CountryCode } from './type';
import type { Country } from './type';

export const australia: Country = {
    name: 'Australia',
    nameFull: 'Australia',
    code: CountryCode.AU,
    displayCode: CountryCode.AU,
    combinedDisplayCode: CountryCode.AU,
    makeMethod: 'makeAustralia',
    theme: false,
    currency: '$',
    currencyName: 'AUD',
    currencyWithCountry: 'AU$',
    maxImageSize: 20000000, // 20MB
    imageOptions: {
        maxSize: 20000000, // 20MB
        fileType: ['.tif','.png','.jpeg','.jpg']
    },
    maxGoodNumberPerClass: 100, // IP Australia only allows 100 goods per class for applications.
    paymentMethodsImageName: 'payment-options-au.png',
    stripeKey: import.meta.env.VITE_STRIP_PUBLIC_KEY_AU,
    autoSelectedInForm: true,
};
